import api from './api';

export interface Anexo {
  id: string;
  nome_arquivo: string;
  nome_original: string;
  tipo: string;
  tamanho: number;
  data_upload: string;
  usuario_id: string;
  usuario_nome: string;
}

export interface AnexoResponse {
  success: boolean;
  anexos: Anexo[];
  message?: string;
}

export interface AnexoUploadResponse {
  success: boolean;
  anexo?: Anexo;
  message?: string;
}

const anexoService = {
  /**
   * Lista anexos de uma tarefa
   */
  async listarAnexosTarefa(tarefaId: string): Promise<AnexoResponse> {
    try {
      const response = await api.get(`/anexos/tarefa/${tarefaId}`);
      return response.data;
    } catch (error: any) {
      console.error('Erro ao listar anexos:', error);
      return {
        success: false,
        anexos: [],
        message: error.response?.data?.message || 'Erro ao carregar anexos'
      };
    }
  },

  /**
   * Faz download de um anexo
   */
  async downloadAnexo(anexoId: string): Promise<string> {
    try {
      const response = await api.get(`/anexos/${anexoId}/download`);
      
      if (response.data.success) {
        return response.data.url;
      } else {
        throw new Error(response.data.message || 'Erro ao obter URL de download');
      }
    } catch (error: any) {
      console.error('Erro ao obter URL de download:', error);
      throw new Error(error.response?.data?.message || 'Erro ao gerar link de download');
    }
  },

  /**
   * Obtém URL para preview de um anexo
   */
  async getPreviewUrl(anexoId: string): Promise<string> {
    try {
      const response = await api.get(`/anexos/${anexoId}/preview`);
      
      if (response.data.success) {
        return response.data.url;
      } else {
        throw new Error(response.data.message || 'Erro ao obter URL de preview');
      }
    } catch (error: any) {
      console.error('Erro ao obter URL de preview:', error);
      throw new Error(error.response?.data?.message || 'Erro ao gerar link de preview');
    }
  },

  /**
   * Faz upload de um anexo
   */
  async uploadAnexo(tarefaId: string, arquivo: File): Promise<AnexoUploadResponse> {
    try {
      const formData = new FormData();
      formData.append('arquivo', arquivo);

      const response = await api.post(`/anexos/tarefa/${tarefaId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error: any) {
      console.error('Erro ao fazer upload:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao fazer upload do arquivo'
      };
    }
  },

  /**
   * Exclui um anexo
   */
  async excluirAnexo(anexoId: string): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await api.delete(`/anexos/${anexoId}`);
      return response.data;
    } catch (error: any) {
      console.error('Erro ao excluir anexo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao excluir anexo'
      };
    }
  }
};

export default anexoService;
